import { useEffect, useState } from "react";
import { DeviceMobile } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

let deferredPrompt = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferredPrompt = e; window.dispatchEvent(new Event("hp-installable")); });
  window.addEventListener("appinstalled", () => { deferredPrompt = null; window.dispatchEvent(new Event("hp-installable")); });
}

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

export function InstallAppButton({ className = "" }) {
  const [, bump] = useState(0);
  useEffect(() => { const f = () => bump((n) => n + 1); window.addEventListener("hp-installable", f); return () => window.removeEventListener("hp-installable", f); }, []);
  if (isStandalone()) return null;
  const canPrompt = !!deferredPrompt;
  if (!canPrompt && !isIOS()) return null;
  const install = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === "accepted") toast.success("Heliopolis app installed — find it on your home screen / desktop");
      deferredPrompt = null; bump((n) => n + 1);
    } else {
      toast.message("Install on iPhone / iPad", { description: "Tap the Share button in Safari, then “Add to Home Screen”.", duration: 8000 });
    }
  };
  return (
    <Button variant="outline" size="sm" className={`w-full rounded-xl ${className}`} onClick={install} data-testid="install-app-button">
      <DeviceMobile size={16} className="mr-2" /> Install app
    </Button>
  );
}
